import {
  legacy_createStore as createStore,
  combineReducers,
  applyMiddleware,
} from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";// this is for redux devtools
import { productListReducer } from "./reducers/productReducers";
import {
  productDetailReducer,
  productDeleteReducer,
  productCreateReducer,
  productUpdateReducer,
  productCreateReviewReducer
} from "./reducers/productReducers";
import { cartReducer } from "./reducers/cartReducer";
import { userLoginReducer } from "./reducers/userReducers";
import { userRegisterReducer } from "./reducers/userReducers";
import { userPasswordResetReducer } from "./reducers/userReducers";
import { siteImagesReducer } from "./reducers/siteImageReducer";
import { siteDocumentsReducer } from "./reducers/siteDocumentReducer";
import {
  userDetailsReducer,
  userListReducer,
  userDeleteReducer,
  userUpdateReducer,
} from "./reducers/userReducers";
import { userUpdateProfileReducer,  visitorsListReducer } from "./reducers/userReducers";
import {
  orderCreateReducer,
  orderDetailsReducer,
  orderPayReducer,
  orderListMyReducer,
  orderListReducer,
  orderDeliverReducer,
  orderEditReducer,
} from "./reducers/orderReducer";
import { couponListReducer } from "./reducers/couponsReducers";
import { themeReducer } from "./reducers/themeReducer";
import { THEME_STORAGE_KEY } from "./constants/themeConstants";

const reducer = combineReducers({
  productList: productListReducer,
  productDetail: productDetailReducer,
  productDelete: productDeleteReducer,
  productCreate: productCreateReducer,
  productUpdate: productUpdateReducer,
  productCreateReview: productCreateReviewReducer,
  cart: cartReducer,
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userPasswordReset: userPasswordResetReducer,
  userDetails: userDetailsReducer,
  userUpdateProfile: userUpdateProfileReducer,
  orderCreate: orderCreateReducer,
  orderDetails: orderDetailsReducer,
  orderPay: orderPayReducer,
  orderDeliver: orderDeliverReducer,
  orderEdit: orderEditReducer,
  orderListMy: orderListMyReducer,
  orderList: orderListReducer,
  userList: userListReducer,
  userDelete: userDeleteReducer,
  userUpdate: userUpdateReducer,
  visitorsList: visitorsListReducer,
  siteImages: siteImagesReducer,
  siteDocuments: siteDocumentsReducer,
  couponList: couponListReducer,
  theme: themeReducer,
});

const cartItemsFromStorage = localStorage.getItem("cartItems")
  ? JSON.parse(localStorage.getItem("cartItems"))
  : [];

const cartCouponFromStorage = localStorage.getItem("coupon")
  ? JSON.parse(localStorage.getItem("coupon"))
  : null;

const paymentMethodFromStorage = localStorage.getItem("paymentMethod")
  ? JSON.parse(localStorage.getItem("paymentMethod"))
  : null;

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const saveShippingAddressFromStorage = localStorage.getItem("shippingAddress")
  ? JSON.parse(localStorage.getItem("shippingAddress"))
  : {};

const userRegisterInfoFromStorage = localStorage.getItem("userRegisterInfo")
  ? JSON.parse(localStorage.getItem("userRegisterInfo"))
  : null;

// Hydrate site-image URLs (hero, section banners, …) from localStorage so the
// hero image URL is already in the Redux store on first render. The
// `fetchSiteImages` action is still dispatched on mount and will refresh the
// cache in the background — but for repeat visitors there's no waiting on
// /api/site-images before the browser can start downloading the hero.
const siteImagesMapFromStorage = (() => {
  try {
    const raw = localStorage.getItem("siteImagesCache_v1");
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
})();

// Hydrate dark/light preference so the first paint matches the user's
// last choice — no flash of light theme for dark-mode users.
const themeFromStorage = (() => {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    return raw === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
})();

const initialState = {
  cart: {
    cartItems: cartItemsFromStorage,
    shippingAddress: saveShippingAddressFromStorage,
    paymentMethod: paymentMethodFromStorage,
    coupon: cartCouponFromStorage,
  },
  userLogin: { userInfo: userInfoFromStorage },
  userRegister: { userRegisterInfo: userRegisterInfoFromStorage },
  siteImages: {
    loading: false,
    error: null,
    images: [],
    imagesMap: siteImagesMapFromStorage,
  },
  theme: { mode: themeFromStorage },
};
const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware)),
);

export default store;
